import { useQuery } from '@tanstack/react-query';
import { fetchFooterConfig } from '../../utils/react-query/query-functions';
import { QUERY_KEYS } from '../../utils/react-query/query-keys';
import { ExtractFnReturnType } from '../../utils/react-query/react-query';

export const useFooterConfig = () => {
  return useQuery<ExtractFnReturnType<typeof fetchFooterConfig>>({
    queryKey: QUERY_KEYS.APP_CONFIG.FOOTER,
    queryFn: fetchFooterConfig,
    staleTime: 60 * 60 * 1000,
    refetchInterval: 60 * 60 * 1000,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};
